import {
    type TextStyle,
    StyleSheet
} from "react-native";
import type {
    TimelineLinkDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    container: {
        ...webStyle({
            textUnderlineOffset: "0.2em",
            textDecorationLine: "none"
        })
    },
    underlined: {
        textDecorationLine: "underline"
    }
});

export const useStyles = ({
    isFocusVisible,
    radiuses,
    borders,
    colors
}: TimelineLinkDynamicStyleType) => {
    const styles = {
        container: {
            ...webStyle({
                textDecorationThickness: borders.line,
                borderRadius: radiuses.xs
            })
        } as Mutable<TextStyle>
    };

    Object.assign(styles.container, getFocusRingStyle({
        colorKey: "default",
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
